const awsExports = {
    Auth: {
        Cognito: {    
            region: process.env.REACT_APP_COGNITO_REGION || '', 
            userPoolId: process.env.REACT_APP_COGNITO_USERPOOL_ID || '',
            userPoolClientId: process.env.REACT_APP_COGNITO_APP_CLIENT_ID || '', 
        }
    }
}
export default awsExports;